import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fl-row-b benefitActionModal__info" }
const _hoisted_2 = { class: "benefitActionModal__detail" }
const _hoisted_3 = { class: "benefitActionModal__detail__user" }
const _hoisted_4 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "姓名：", -1)
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "工号：", -1)
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "手机号：", -1)
const _hoisted_12 = { class: "right" }
const _hoisted_13 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "部门：", -1)
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "公司：", -1)
const _hoisted_18 = { class: "right" }
const _hoisted_19 = { class: "detailTable" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("caption", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "总里程:", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "总时长:", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "油补金额:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "补贴周期:", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, "当月上限:", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "剩余额度:", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, "车辆名称:", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, "车牌号码:", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, "车类型:", -1)
const _hoisted_31 = { colspan: "3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, "提交日期:", -1)
const _hoisted_33 = { colspan: "3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "benefitActionModal__map" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "轨迹地图"),
  /*#__PURE__*/_createElementVNode("div", { id: "mapContainer" })
], -1)
const _hoisted_35 = { class: "benefitActionModal__info__available" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "可发放补贴：", -1)
const _hoisted_37 = { class: "tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    class: "benefitActionModal",
    width: "940px",
    onCancel: _ctx.onCancel
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", null, "行程单号：" + _toDisplayString(_ctx.detailData.businessNo), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.detailData.userName || '---'), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.detailData.jobNumber || '---'), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.detailData.phone ? `${_ctx.detailData.phone.substr(0,3)}****${_ctx.detailData.phone.substr(7)}` : '---'), 1)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.detailData.departmentName || '---'), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.detailData.enterpriseName || '---'), 1)
            ])
          ]),
          _createElementVNode("table", _hoisted_19, [
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("tr", null, [
              _hoisted_22,
              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.drivenDistance || '---') + "公里", 1),
              _hoisted_23,
              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.totalDuration || '---'), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_24,
              _createElementVNode("td", null, "￥" + _toDisplayString(_ctx.formatWithIntl(_ctx.toLocalUnit(+(_ctx.detailData.amount || 0)))), 1),
              _hoisted_25,
              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.supplementDate), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_26,
              _createElementVNode("td", null, "￥" + _toDisplayString(!_ctx.detailData.quota && (_ctx.detailData.quota !== 0) ? '--' :_ctx.formatWithIntl(_ctx.toLocalUnit(+( _ctx.detailData.quota|| 0)))), 1),
              _hoisted_27,
              _createElementVNode("td", null, "￥" + _toDisplayString(!_ctx.detailData.quota && (_ctx.detailData.quota !== 0) ? '--' : _ctx.detailData.remainingQuota), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_28,
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.detailData.vehicleName || '---'), 1)
              ]),
              _hoisted_29,
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.detailData.licensePlate || '---'), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_30,
              _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.detailData.carType === 0 ? '公车' : _ctx.detailData.carType === 1 ? '私车' : '---'), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_32,
              _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatDate(_ctx.detailData.createTime)), 1)
            ])
          ])
        ]),
        _hoisted_34
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formatWithIntl(_ctx.toLocalUnit(+(_ctx.detailData.availableAmount|| 0)))) + "元", 1)
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.tableColumns,
        "row-key": "id",
        "data-source": _ctx.detailData.pointLog,
        pagination: false
      }, null, 8, ["columns", "data-source"])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}